import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import { DATA_REQUEST_ASYNC } from './constants'

export default function () {
  const initialState = {
    data: null,
    loader: false,
    error: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case COMPANY_FILTER_CHANGE:
        return { ...state, loader: true }
      case DATA_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true }
      case DATA_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: action.payload.data,
          loader: false,
        }
      case DATA_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          loader: false,
          error: action.error,
          data: null,
        }
      case DATA_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }

      default:
        return state
    }
  }
}
